import React from 'react'
import clsx from 'clsx'
import { Autocomplete, useTheme } from '@mui/material'
import { Add } from '@mui/icons-material'
import { SearchNormal } from 'iconsax-react'

import useStyles, { StyledTextField } from './styles'

const AutoInput = ({ addText, options, renderOption, onSelect }) => {
  const [searching, setSearching] = React.useState(false)
  const [searchVal, setSearchVal] = React.useState('')
  const theme = useTheme()

  const classes = useStyles()

  const handleKeyDown = React.useCallback(e => {
    if (e.key === 'Escape') {
      setSearching(false)
    }
  }, [])

  if (!searching) {
    return (
      <div
        className={clsx(classes.box, classes.addTagBox)}
        onClick={() => setSearching(true)}
      >
        <Add fill='#8F8F8F' className={clsx(classes.icon, classes.muiIcon)} />

        {addText}
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <Autocomplete
        value={searchVal}
        isOptionEqualToValue={(option, value) => {
          if (value.trim.length === 0) {
            return true
          }

          return option.name
            .toLocaleLowerCase()
            .includes(value.toLocaleLowerCase())
        }}
        options={options}
        sx={{ width: 300 }}
        onChange={(event, newValue) => {
          setSearchVal('')
          setSearching(false)
          onSelect(newValue)
        }}
        filterOptions={(options, state) => {
          const { inputValue } = state

          const val = inputValue.trim().toLocaleLowerCase()

          if (val.length === 0) {
            return options
          }

          return options.filter(opt =>
            (opt.name?.toLocaleLowerCase() ?? opt).includes(val)
          )
        }}
        renderInput={params => (
          <StyledTextField
            {...params}
            type='text'
            size='small'
            variant='outlined'
            onKeyDown={handleKeyDown}
            autoFocus
          />
        )}
        getOptionLabel={() => ''}
        renderOption={renderOption}
        className={classes.textField}
        selectOnFocus
        disableClearable
        includeInputInList
      />

      <SearchNormal size={theme.size.sm} className={classes.inputIcon} />
    </div>
  )
}

export default AutoInput
